export default "__VITE_ASSET__NNQdIiTO__"